var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDemo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 20.5434C14 16.9296 16.9296 14 20.5434 14H68.5279C72.1417 14 75.0713 16.9296 75.0713 20.5434C75.0713 24.1571 72.1417 27.0867 68.5279 27.0867H20.5434C16.9296 27.0867 14 24.1571 14 20.5434ZM20.5434 18.3622C19.3388 18.3622 18.3622 19.3388 18.3622 20.5434C18.3622 21.7479 19.3388 22.7245 20.5434 22.7245H68.5279C69.7325 22.7245 70.709 21.7479 70.709 20.5434C70.709 19.3388 69.7325 18.3622 68.5279 18.3622H20.5434Z",
    fill: "#222831",
    stroke: "#F9F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 55.4413C14 51.8275 16.9296 48.8979 20.5434 48.8979H68.5279C72.1417 48.8979 75.0713 51.8275 75.0713 55.4413C75.0713 59.0551 72.1417 61.9847 68.5279 61.9847H20.5434C16.9296 61.9847 14 59.0551 14 55.4413ZM20.5434 53.2602C19.3388 53.2602 18.3622 54.2367 18.3622 55.4413C18.3622 56.6459 19.3388 57.6224 20.5434 57.6224H68.5279C69.7325 57.6224 70.709 56.6459 70.709 55.4413C70.709 54.2367 69.7325 53.2602 68.5279 53.2602H20.5434Z",
    fill: "#222831",
    stroke: "#F9F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3623 24.9057C18.3623 23.7011 19.3388 22.7246 20.5434 22.7246H68.528C69.7326 22.7246 70.7091 23.7011 70.7091 24.9057V51.0791C70.7091 52.2837 69.7326 53.2602 68.528 53.2602H20.5434C19.3388 53.2602 18.3623 52.2837 18.3623 51.0791V24.9057ZM22.7245 27.0868V48.898H66.3469V27.0868H22.7245Z",
    fill: "#222831",
    stroke: "#F9F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5359 57.6223C45.2366 57.6223 45.8946 57.9589 46.3046 58.527L55.7491 71.6137C56.454 72.5905 56.2337 73.9538 55.2569 74.6588C54.2801 75.3637 52.9168 75.1433 52.2118 74.1665L44.5359 63.5305L36.8601 74.1665C36.1551 75.1433 34.7918 75.3637 33.815 74.6588C32.8382 73.9538 32.6179 72.5905 33.3228 71.6137L42.7673 58.527C43.1773 57.9589 43.8353 57.6223 44.5359 57.6223Z",
    fill: "#222831",
    stroke: "#F9F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4111 29.9751C62.225 30.8631 62.1651 32.2428 61.2771 33.0568L48.1904 45.0529C47.4307 45.7493 46.2874 45.8189 45.4488 45.2199L39.205 40.7601L32.8682 46.1917C31.9536 46.9756 30.5766 46.8697 29.7927 45.9551C29.0088 45.0405 29.1147 43.6636 30.0293 42.8796L37.6632 36.3363C38.425 35.6833 39.5339 35.6343 40.3504 36.2175L46.5458 40.6428L58.3294 29.8411C59.2174 29.0272 60.5971 29.0871 61.4111 29.9751Z",
    fill: "#BAE047",
    stroke: "#F9F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemo);
export default __webpack_public_path__ + "static/media/demo.f5c79b5a329416b1955ae1a1bc43eecb.svg";
export { ForwardRef as ReactComponent };